import {ChangeDetectionStrategy, Component, inject} from '@angular/core';import {SmsirButtonHttpLoadingDirective} from '@shared/directives/smsir-button-http-loading.directive';

import {NgFor, NgIf} from '@angular/common';
import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

export interface BootstrapperNotifyMessage {
  title: string;
  id: number;
  showAtEntry: boolean;
  content: string;
}

export interface BootstrapperNotifyModalData {
  modalHeader: string;
  messages: BootstrapperNotifyMessage[];
}

@Component({
  selector: 'app-bootstrapper-notify-modal',
  standalone: true,
  imports: [NgIf, NgFor, ButtonComponent,
    SmsirButtonHttpLoadingDirective,
  ],
  templateUrl: './bootstrapper-notify-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BootstrapperNotifyModalComponent {
  private readonly modalRef = inject<ModalRef<number[] | null>>(ModalRef);
  private readonly data = inject<BootstrapperNotifyModalData>(MODAL_DATA);

  readonly modalHeader = this.data.modalHeader;
  readonly messages = this.data.messages ?? [];

  onSubmit(): void {
    this.modalRef.close(this.messages.map((item) => item.id));
  }
}
